export default __webpack_public_path__ + "static/media/claim-prizes.98e84073.png";